// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J10-","colBig":"styles_colBig__IK7R9","colSmall":"styles_colSmall__2pCM3"};